import React, { useState, useEffect, Fragment } from "react";
import { useHistory } from "react-router-dom";
import { API_URL, scroll } from "../helpers";
import Hdg from "../components/Hdg";
import Alert from "../components/Alert";

const CharityRegSubmitted = ({ location }) => {
	const [names, setNames] = useState({
		id: "0",
	});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const history = useHistory();

	useEffect(() => {
		scroll();
		init(location.state.id || "0");

		// eslint-disable-next-line
	}, []);

	const init = async (id) => {
		const url = new URL(`${API_URL}/crSubmittedInit`);
		const params = {
			id,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setNames({
					id: json.id,
					data: json.data,
				});
				setAlert({});
			} else {
				history.push("/registration/info");
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<div id="full-column">
			<Hdg />
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<Fragment>
					<div className="alert well-sm alert-success" role="alert">
						<i className="fa fa-check-square-o" /> &nbsp;Champions{" "}
						<span style={{ fontStyle: "italic" }}>fore</span> Charity
						Registration Submitted
					</div>

					<p>
						Thank you! You have successfully submitted your Champions{" "}
						<span style={{ fontStyle: "italic" }}>fore</span> Charity
						registration to VTO for participatation in the 2026-2027 fundraising
						season. An email with important details about the program has been
						sent to <strong>{names.data.email}</strong>, please click below to
						generate a printable version of your registration details for your
						records.
					</p>

					<div id="left-column" style={{ padding: "0" }}>
						<table className="approved">
							<thead>
								<tr>
									<th>Status</th>
									<th className="left">Charity Name</th>
									<th>Authorized Signature</th>
									<th>Date</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>{names.data.status}</td>
									<td className="left">{names.data.charity}</td>
									<td>{names.data.signature}</td>
									<td>{names.data.date}</td>
								</tr>
							</tbody>
						</table>

						<div className="homebutton">
							<a
								href={`https://valerotexasopen.com/championsforecharity/registrationprint/?${names.data.token}`}
								target="_blank"
								rel="noopener noreferrer"
							>
								<i className="fa fa-print" /> &nbsp;Printable Registration
								Details
								<i className="fa fa-angle-right" />
							</a>
						</div>
					</div>
					<div
						id="right-column"
						style={{
							width: "35%",
							paddingTop: "15px",
							paddingRight: "0",
							paddingLeft: "0",
						}}
					/>
				</Fragment>
			)}
		</div>
	);
};

export default CharityRegSubmitted;
